import script from "./CandidatesNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidatesNavbar.vue?vue&type=script&setup=true&lang=js"

import "./CandidatesNavbar.vue?vue&type=style&index=0&id=27dfc747&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dfc747"]])

export default __exports__